import React from "react";

const LoaderPage = () => {
    return (
        <div style={{ backdropFilter: "blur(0.5px)" }}
            className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-[1px] bg-black bg-opacity-10">
            <div className="w-16 h-16 border-4 border-white border-dashed rounded-full animate-spin"></div>
        </div>
    );
};

export default LoaderPage;
